/**
 * 权限管理页：角色与菜单分组（与侧边栏 permission 码一致）
 */
export const ROLE_OPTIONS = [
  { value: 'chairman', label: '领导', desc: '查看决策类页面，一般不配置细项维护权限' },
  { value: 'secretary', label: '助理', desc: '日常数据维护、上传与疑似关联确认等' },
  { value: 'admin', label: '管理员', desc: '用户与角色权限、系统配置' },
]

export const PERMISSION_GROUPS = [
  {
    title: '数据驾驶舱',
    items: [
      { code: 'data-report', label: '数据报告' },
      { code: 'penetration', label: '股权穿透' },
      { code: 'chip', label: '筹码成本' },
      { code: 'trade', label: '交易趋势' },
    ],
  },
  {
    title: '股东管理',
    items: [
      { code: 'core', label: '核心股东配置' },
      { code: 'core-control-list', label: '核心股东控制' },
      { code: 'suspicious-push', label: '疑似关联处理' },
      { code: 'shareholder-uniqueness', label: '股东档案' },
    ],
  },
  {
    title: '规则配置',
    items: [
      { code: 'rule', label: '基础规则' },
      { code: 'rule-special', label: '特殊规则' },
    ],
  },
  {
    title: '助理工作台',
    items: [
      { code: 'upload-shareholder', label: '上传名册' },
      { code: 'stock-price', label: '股票价格' },
      { code: 'suspicious-confirm', label: '确认疑似关联' },
    ],
  },
  {
    title: '权限与反馈',
    items: [
      { code: 'permission', label: '用户权限' },
      { code: 'feedback', label: '问题反馈' },
    ],
  },
]

export function roleLabel(role) {
  return ROLE_OPTIONS.find((r) => r.value === role)?.label || role || '—'
}
